/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Field_Modalities_WordsInputs */

const en_us2_search_field_modalities_words = /** @type {(inputs: Search_Field_Modalities_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`running swimming sport modality`)
};

const pt_br2_search_field_modalities_words = /** @type {(inputs: Search_Field_Modalities_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`corrida natacao esporte modalidade`)
};

const es_419_search_field_modalities_words = /** @type {(inputs: Search_Field_Modalities_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`correr natacion deporte modalidad`)
};

const pt_pt2_search_field_modalities_words = /** @type {(inputs: Search_Field_Modalities_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`corrida natacao desporto modalidade`)
};

const fr_fr2_search_field_modalities_words = /** @type {(inputs: Search_Field_Modalities_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`course natation sport discipline`)
};

const de_de2_search_field_modalities_words = /** @type {(inputs: Search_Field_Modalities_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`laufen schwimmen sport sportart`)
};

const it_it2_search_field_modalities_words = /** @type {(inputs: Search_Field_Modalities_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`corsa nuoto sport disciplina`)
};

/**
* | output |
* | --- |
* | "running swimming sport modality" |
*
* @param {Search_Field_Modalities_WordsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_field_modalities_words = /** @type {((inputs?: Search_Field_Modalities_WordsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Field_Modalities_WordsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_field_modalities_words(inputs)
	if (locale === "es-419") return es_419_search_field_modalities_words(inputs)
	if (locale === "pt-PT") return pt_pt2_search_field_modalities_words(inputs)
	if (locale === "fr-FR") return fr_fr2_search_field_modalities_words(inputs)
	if (locale === "de-DE") return de_de2_search_field_modalities_words(inputs)
	if (locale === "it-IT") return it_it2_search_field_modalities_words(inputs)
	return en_us2_search_field_modalities_words(inputs)
});
export { search_field_modalities_words as "search.field_modalities_words" }